import UserSettingsPage from './UserSettingsPage'

export default UserSettingsPage
